import React from 'react';
import WorkoutsList from 'fit/pages/strength/WorkoutsList';
const TodaysWorkoutListRoute=()=>{
    return (<WorkoutsList getToday={true}/>);
};

export default TodaysWorkoutListRoute;